import { useTranslation } from "react-i18next"
import type { FC } from "react"

import type { DeviceMarker } from "types/geolocation.types"

import useRoutes from "helpers/hooks/useRoutes"
import useInstalledOnRef from "helpers/hooks/devices/useInstalledOnRef"
import EntityPopup, { type EntityPopupField } from "./EntityPopup"
import { getFeatureFields } from "./featureFields"

interface DevicePopupProps {
  data: DeviceMarker
  hideButton?: boolean
}

const DevicePopup: FC<DevicePopupProps> = ({ data, hideButton }) => {
  const { groups, device } = data
  const { baseOrgURL } = useRoutes()
  const { t } = useTranslation()
  const { ref: installedOn, isLoading: installedOnLoading } = useInstalledOnRef(
    device.settings,
  )

  const fields: EntityPopupField[] = [
    ...getFeatureFields("Device", { ...device, ...device.settings }, t),
    {
      label: t("device_table.INSTALLED_ON"),
      type: "entity-link",
      value: installedOn ? [installedOn] : [],
      loading: installedOnLoading,
    },
    { label: t("device_groups.GROUPS"), type: "chips", value: groups ?? [] },
  ]

  return (
    <EntityPopup
      entity="device"
      name={device.name}
      fields={fields}
      id={device.less_id}
      href={hideButton ? undefined : `${baseOrgURL}/devices/${device.less_id}`}
    />
  )
}

export default DevicePopup
